var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      dense: "",
      label: _vm._f("cap")(
        _vm.$t("select") + " " + _vm.$tc("agents", 1, { count: "" })
      ),
      items: _vm.colleagues,
      "item-value": "USR_ID",
      "return-object": "",
      "prepend-icon": "perm_identity",
      disabled: _vm.disabled,
      "persistent-hint": _vm.hint.trim().length > 0,
      hint: _vm.hint
    },
    on: {
      input: function($event) {
        return _vm.$emit("update:agent", _vm.agentTmp)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(data) {
          return [
            _c(
              "v-chip",
              { attrs: { small: "" } },
              [
                _c("wz-avatar", {
                  attrs: {
                    size: "28px",
                    src:
                      _vm.domaine +
                      "/public/media/user/small/" +
                      data.item.USR_ID +
                      "_avatar.jpg",
                    username:
                      data.item.USR_FIRST_NAME + " " + data.item.USR_LAST_NAME
                  }
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(data.item.USR_FIRST_NAME) +
                    " " +
                    _vm._s(data.item.USR_LAST_NAME) +
                    "\n      "
                ),
                data.item.USR_ID == _vm.$store.state._User.id
                  ? _c("span", { staticClass: "ml-1" }, [
                      _vm._v("(" + _vm._s(_vm.$t("me")) + ")")
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        }
      },
      {
        key: "item",
        fn: function(data) {
          return [
            _c("wz-avatar", {
              attrs: {
                size: "28px",
                src:
                  _vm.domaine +
                  "/public/media/user/small/" +
                  data.item.USR_ID +
                  "_avatar.jpg",
                username:
                  data.item.USR_FIRST_NAME + " " + data.item.USR_LAST_NAME
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group__selections__comma" }, [
              _vm._v(
                "\n      " +
                  _vm._s(data.item.USR_FIRST_NAME) +
                  " " +
                  _vm._s(data.item.USR_LAST_NAME) +
                  "\n      "
              ),
              data.item.USR_ID == _vm.$store.state._User.id
                ? _c("span", { staticClass: "ml-1" }, [
                    _vm._v("(" + _vm._s(_vm.$t("me")) + ")")
                  ])
                : _vm._e()
            ])
          ]
        }
      }
    ]),
    model: {
      value: _vm.agentTmp,
      callback: function($$v) {
        _vm.agentTmp = $$v
      },
      expression: "agentTmp"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-054bf88f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054bf88f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectOneAgent.vue
// module id = null
// module chunks = 